import Log from '@/Logger';

/**
 * API エラーの統一ハンドリング
 * GraphQLエラー、ネットワークエラー、その他のエラーを適切に処理する
 */
export function handleError(error: any): Error {
    const logger = Log.getLogger();

    // GraphQLエラーの場合
    if (error.errors && error.errors.length > 0) {
        const graphqlError = error.errors[0];
        logger.api.error('API Client', 'GraphQL Error', JSON.stringify({
            message: graphqlError.message,
            code: graphqlError.extensions?.code,
            path: graphqlError.path
        }));

        // ユーザーフレンドリーなエラーメッセージに変換
        return new Error(formatErrorMessage(graphqlError.message));
    }

    // ネットワークエラーの場合
    if (error.networkError) {
        logger.api.error('API Client', 'Network Error', JSON.stringify({ error: error.networkError }));
        return new Error('ネットワークエラーが発生しました。接続を確認してください。');
    }

    // 認証エラーの場合
    if (error.message?.includes('Access token') || error.message?.includes('auth')) {
        logger.api.error('API Client', 'Auth Error', JSON.stringify({ error }));
        return new Error('認証エラーが発生しました。再ログインしてください。');
    }

    // その他のエラー
    logger.api.error('API Client', 'Unknown Error', JSON.stringify({ error }));
    return new Error(error.message || '予期しないエラーが発生しました。');
}

/**
 * エラーメッセージをユーザーフレンドリーに変換
 */
function formatErrorMessage(message: string | undefined): string | undefined {
    // messageが空またはundefinedの場合はそのまま返す
    if (!message) return message;

    // 一般的なGraphQLエラーメッセージの変換
    if (message.includes('not found')) {
        return 'データが見つかりませんでした。';
    }

    if (message.includes('permission') || message.includes('forbidden')) {
        return 'この操作を実行する権限がありません。';
    }

    if (message.includes('validation')) {
        return '入力データに問題があります。';
    }

    // デフォルトはそのまま返す
    return message;
}

/**
 * エラーの種類を判定
 */
export function getErrorType(error: any): string {
    if (error.errors && error.errors.length > 0) {
        return 'GraphQL';
    }

    if (error.networkError) {
        return 'Network';
    }

    if (error.message?.includes('auth')) {
        return 'Auth';
    }

    return 'Unknown';
}
